import { withModalProvider } from "../../hoc/withModalProvider";

import { HousingMajors as View, IProps } from "./HousingMajors";

export const HousingMajors = withModalProvider<IProps>(View);
